import { useState } from "react";
import { toast } from "sonner";
import { Receipt } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api, errMsg } from "../lib/api";
import { useT } from "../i18n";

export default function ResetPasswordPage() {
  const { t } = useT();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm space-y-8">
        <div className="flex items-center gap-2 text-slate-900">
          <Receipt size={24} weight="bold" />
          <span className="font-heading font-bold tracking-tight">Pellku</span>
        </div>
        {done ? (
          <div className="space-y-4">
            <h2 className="font-heading text-2xl font-bold text-slate-900 tracking-tight">{t("rp_done_title")}</h2>
            <p className="text-sm text-slate-500">{t("rp_done_sub")}</p>
            <Button data-testid="back-to-login-btn" onClick={() => { window.location.href = "/"; }} className="w-full h-11 rounded-none bg-slate-900 hover:bg-slate-700">{t("backToLogin")}</Button>
          </div>
        ) : (
          <>
            <div>
              <h2 className="font-heading text-2xl font-bold text-slate-900 tracking-tight">{t("rp_title")}</h2>
              <p className="text-sm text-slate-500 mt-1">{t("rp_sub")}</p>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <Input data-testid="new-password-input" required type="password" minLength={6} placeholder={t("newPassword")} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-11" />
              <Button data-testid="reset-password-btn" type="submit" disabled={busy || !token} className="w-full h-11 rounded-none bg-slate-900 hover:bg-slate-700">
                {busy ? t("pleaseWait") : t("resetPassword")}
              </Button>
              {!token && <p className="text-xs text-red-500">{t("missingToken")}</p>}
            </form>
          </>
        )}
      </div>
    </div>
  );
}
